import React from "react";

import { animated } from "@react-spring/web";

import { Player, Statistics } from "src/components/common";
import { useContent } from "./hooks";

export const Content = React.memo(() => {
  const { getContentProps, getPlayerProps, getStatisticsProps, values } =
    useContent();
  return (
    <div {...getContentProps()}>
      <animated.div {...getPlayerProps()}>
        {values.isMonitor && <Player />}
      </animated.div>
      <animated.div {...getStatisticsProps()}>
        <Statistics />
      </animated.div>
    </div>
  );
});

Content.displayName = "Content";
